module.exports = __webpack_public_path__ + "img/step4-d.08cbb3e0.png";